module.exports = __webpack_public_path__ + "img/bodycheck8.e9834f10.png";